/**
 * Central definition point for localStorage and sessionStorage keys.
 * This helps avoid typos and makes it easier to manage storage keys across the application.
 */

export const StorageKeys = {
    PointRedirectDomain: 'point_redirect_domain',
} as const;